import './header.scss';

export default function Header() {
    return (
        <div className="header">
            <h1 className="title">Ch.</h1>
        </div>
    )
}